import { buildProps } from '@lit-element/utils'
import type { ExtractPropTypes } from 'vue'
import type ellipsis from './ellipsis.vue'

export const ellipsisProps = buildProps({
  content: {
    type: String,
    default: '',
  },
  /**
   * @description 定义文本长度
   */
  maxLength: {
    type: Number,
    default: 100,
  },
  width: {
    type: String,
    default: '500',
  },
  /**
   * @description 是否展示tooltip
   */
  showTooltip: {
    type: Boolean,
    default: true,
  },
  maxLines: {
    type: Number,
    default: 1,
  },
  expandTrigger: {
    type: String,
    default: 'hover', // 默认值为 'hover'
  },
  popperContentWidth: {
    type: String,
    default: 'auto',
  },
  effect: {
    type: String,
    default: 'dark',
  },
} as const)

export type EllipsisProps = ExtractPropTypes<typeof ellipsisProps>
export type EllipsisInstance = InstanceType<typeof ellipsis>
